import { Variant } from '../types'

export interface TransformedVariant extends Variant {
  enableAddToBasket: boolean
}

// @TODO: REBUILD-8622
export const variant = (variant, enableAddToBasket): TransformedVariant => {
  return {
    ...variant,
    enableAddToBasket,
  }
}
